export const storageIDB = 'indexeddb',
    storageRemote = 'rest-api',
    storageFireStore = 'firestore';